import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Muster / assembly point.
export const MUSTER_POINT_NODES: IconNode = [
  [
    'path',
    {
      key: 'muster-point-0',
      d: 'M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-1',
      d: 'M3.5 3.5L7.5 7.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-2',
      d: 'M7.5 4.5V7.5H4.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-3',
      d: 'M20.5 3.5L16.5 7.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-4',
      d: 'M16.5 4.5V7.5H19.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-5',
      d: 'M3.5 20.5L7.5 16.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-6',
      d: 'M7.5 19.5V16.5H4.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-7',
      d: 'M20.5 20.5L16.5 16.5',
    },
  ],
  [
    'path',
    {
      key: 'muster-point-8',
      d: 'M16.5 19.5V16.5H19.5',
    },
  ],
]

export const MusterPointIcon: LucideIcon = createLucideIcon(
  'muster-point',
  MUSTER_POINT_NODES,
)
